import React from 'react'
import PropTypes from 'prop-types'

const IconButton = ({ children, onClick }) => (
   <div
      className="ui-icon-button"
      onClick={onClick}
      onKeyDown={onClick}
      role="button"
      tabIndex="0">
      {children}
   </div>
)

IconButton.propTypes = {
   children: PropTypes.node.isRequired,
   onClick: PropTypes.func
}

IconButton.defaultProps = {
   onClick: undefined
}

export default IconButton
